import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAugmentedJQuery, IController, IModule, IOnChangesObject, IScope} from "angular";
import {l} from "../../../types/typescriptdefinisjoner_lederplan";
import {changesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {DokumentRessurs} from "felles/tjenester/ressurser/DokumentRessurs";
import {Debugger} from "debug";

const css = require('./inlinePdfjsVisning.scss');
const debug: Debugger = require('debug')('InlinePdfjsVisning');

/**
 * viser angitt pdf dokument versjon i en iframe vhja pdfjs
 */
export class InlinePdfjsVisning implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wkInlinePdfjsVisning', {
                bindings: {
                    dokumentversjon: '<',
                    forespurtAnnoteringId: '<',
                },
                controller: InlinePdfjsVisning.forInjisering(),
                template: `<iframe ng-src="{{$ctrl.url}}"></iframe>`,
                transclude: true
            })
    }

    static forInjisering() {
        return [regNavn.ng.$scope, regNavn.ng.$element, DokumentRessurs.regNavn, InlinePdfjsVisning]
    }

    constructor(private $scope: IScope, private $element: IAugmentedJQuery, private dokumentRessurs: DokumentRessurs) {
    }

    dokumentversjon: l.DokumentVersjonModell; //settes via bindings
    forespurtAnnoteringId: string; //settes via bindings

    url: string;

    $onChanges(endringer: IOnChangesObject): void {
        if (changesInneholder(endringer, 'dokumentversjon'))
            this.initUrl();
    }
    
    //hjelpemetoder

    private initUrl() {
        this.url = this.dokumentRessurs.pdfjsDokumentViserUrl(this.dokumentversjon, this.forespurtAnnoteringId);
        debug('åpner med pdfjs', this.url);
    }

}
    